export default __webpack_public_path__ + "static/media/Pendant of Tribulations Everlasting.8eb89291.jpg";